<template>
  <div>
    <SkeletonLoader
      v-if="isLoading"
      show-animation
      class="overview-inbox__loader"
      data-testid="overview-inbox-loader"
    >
      <div v-for="loadingItem of 3" :key="loadingItem" />
    </SkeletonLoader>

    <transition v-else name="fade" mode="out-in" appear>
      <div v-if="showNewsCard" class="overview-inbox">
        <div v-for="(feed, indexFeed) in newsFeed" :key="feed.code">
          <CardNews
            data-testid="card-news"
            :data="feed"
            @close="() => removeNewsFeed(indexFeed, feed)"
            @open="() => viewNewsFeed(feed)"
          />
        </div>
      </div>

      <div v-else-if="hasEmptyMessage" key="message">
        <slot name="empty-message" />
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Emit } from 'vue-property-decorator';
import { Carousel, Slide } from 'vue-carousel';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';
import CardNews from '../CardNews/CardNews.vue';
import { NewsAPI, IFeedItem } from '@/modules/home/services/news';

const newsApi = new NewsAPI();

@Component({
  components: {
    Carousel,
    Slide,
    CardNews,
    SkeletonLoader
  }
})
export default class OverviewInbox extends Vue {
  public showSuggestionModal = false;

  private newsFeed = [] as IFeedItem[];
  private isLoading = false;

  async created() {
    await this.loadData();
  }

  public async loadData() {
    try {
      this.isLoading = true;
      const response = await newsApi.getHomeNews();
      this.newsFeed = response.feed || [];
    } finally {
      this.isLoading = false;
    }
  }

  @Emit('viewNews')
  public viewNewsFeed(news: IFeedItem): IFeedItem {
    return news;
  }

  @Emit('removeNews')
  public removeNewsFeed(indexFeed: number, feed: IFeedItem) {
    const animationDuration = 500;

    setTimeout(() => {
      this.newsFeed = this.newsFeed.filter((_, index) => index !== indexFeed);
    }, animationDuration);

    return feed;
  }

  private get showNewsCard() {
    return this.newsFeed.length > 0;
  }

  private get hasEmptyMessage() {
    return this.$slots['empty-message'];
  }
}
</script>
<style lang="less" scoped>
.overview-inbox {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: @size-spacing-x500;
}

.overview-inbox__loader {
  width: 100%;
  height: 100%;
  display: flex;

  > div {
    &:not(:last-of-type) {
      margin-right: @size-spacing-x500;
    }

    border-radius: 8px;
    flex: 1;
    height: 300px;

    @media @mobile {
      &:nth-of-type(1) {
        display: none;
      }
    }

    @media @tabletDown {
      &:nth-of-type(2) {
        display: none;
      }
    }
  }
}
</style>
